import React, { useEffect, useState } from "react";
import emojiData from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { usePopper } from "react-popper";
import { useAddReactionMutation } from "../../__generated__/api";
import EmojiList from "./emoji-short.json";
import Styles from "./EmojiPicker.module.scss";

const EMOJI_REVERSE = Object.entries(EmojiList).toIdMap(([, value]) => value, ([key]) => key.substring(1, key.length - 1));

export interface EmojiPickerProps {
    chatId: string;
    messageId: string;
    target: HTMLElement;
    onHide: () => void;
    placement?: "right" | "left"
}

export default function EmojiPicker({
    chatId, messageId, target, onHide, placement,
}: EmojiPickerProps) {
    const [addReaction] = useAddReactionMutation();

    const [popperElement, setPopperElement] = useState<HTMLDivElement | null>();
    const [arrowElement, setArrowElement] = useState<HTMLDivElement | null>();
    const [isShown, setIsShown] = useState(false);

    const { styles, attributes } = usePopper(target, popperElement, {
        placement,
        strategy: "absolute",

        modifiers: [{
            name: "arrow",
            options: {
                padding: 20,
                element: arrowElement,
            },
        }],
    });

    useEffect(() => {
        if (target) {
            setTimeout(() => {
                setIsShown(true);
            }, 100);
        }
    }, [target]);

    return (
        <div
            ref={setPopperElement}
            style={styles.popper}
            {...attributes.popper}
            className={Styles.popper}
            onBlur={evt => {
                if (!popperElement?.contains(evt.target)) {
                    onHide();
                }
            }}
        >

            <Picker
                autoFocus
                data={emojiData}
                theme="light"
                onClickOutside={() => {
                    if (isShown) {
                        onHide();
                    }
                }}
                onEmojiSelect={emoji => {
                    onHide();
                    const reaction = EMOJI_REVERSE[emoji.native]
                            ?? emoji.shortcodes.substring(1, emoji.shortcodes.length - 1);
                    addReaction({
                        variables: {
                            reaction: {
                                chatId,
                                messageId,
                                reaction,
                            },
                        },
                    });
                }}
            />
            <div ref={setArrowElement} style={styles.arrow} />
        </div>
    );
}

EmojiPicker.defaultProps = {
    placement: "right",
};
